const initialState = {
  fetching: false,
  fetched: false,
  nbResult: 0,
  pageSize: 10,
  paginationPage: 1,
  items: [],
  selected: [],
  error: null,
  filter: {
    label: "",
    category: []
  },
  updating: false,
  updated: false
};

export const taskTypesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "INIT_TASK_TYPES_LIST": {
      return {
        ...state,
        fetching: false,
        fetched: false,
        items: [],
        selected: [],
        error: null
      };
    }
    case "SET_TASKS_LIST": {
      return {
        ...state,
        items: action.items
      };
    }
    case "SET_TASK_TYPE_SELECTED": {
      return {
        ...state,
        selected: action.selected
      };
    }
    case "FETCH_TASK_TYPES_LIST_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_TASK_TYPES_LIST_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        selected: [],
        nbResult: action.payload.data.nbResult,
        items: action.payload.data.data
      };
    }
    case "FETCH_TASK_TYPES_LIST_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        fetching: false,
        items: [],
        error
      };
    }
    case "SET_TASK_TYPES_LIST_PAGINATION_PAGE": {
      return { ...state, paginationPage: action.pageNumber };
    }
    case "SET_TASK_TYPE_LIST_FILTER_TITLE": {
      return {
        ...state,
        filter: { ...state.filter, label: action.title },
        paginationPage: 1
      };
    }
    case "SET_TASK_TYPES_LIST_PAGE_SIZE": {
      return {
        ...state,
        pageSize: action.pageSize,
        paginationPage: 1
      };
    }
    case `TOGGLE_BILLABLE_TASK_TYPE_PENDING`: {
      return { ...state, updated: false, updating: true };
    }
    case `TOGGLE_BILLABLE_TASK_TYPE_FULFILLED`: {
      return {
        ...state,
        updating: false,
        updated: true
      };
    }
    case `TOGGLE_BILLABLE_TASK_TYPE_REJECTED`: {
      return {
        ...state,
        updating: false,
        updated: false
      };
    }
    default:
      return state;
  }
};

const initialStateCategory = {
  fetching: false,
  fetched: false,
  items: [],
  selected: [],
  error: null
};

export const taskCategoryReducer = (state = initialStateCategory, action) => {
  switch (action.type) {
    case "INIT_TASK_CATEGORIE_LIST": {
      return {
        ...state,
        fetching: false,
        fetched: false,
        items: [],
        selected: [],
        error: null
      };
    }
    case "SET_TASK_CATEGORY_SELECTED": {
      return {
        ...state,
        selected: action.selected
      };
    }
    case "FETCH_TASK_CATEGORIES_LIST_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_TASK_CATEGORIES_LIST_FULFILLED": {
      let data = action.payload.data.data;
      let selected = data.map(category => category.id);
      selected.unshift(null);
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data,
        selected: selected
      };
    }
    case "FETCH_TASK_CATEGORIES_LIST_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        fetching: false,
        items: [],
        error
      };
    }
    default:
      return state;
  }
};

const initialcountTaskType = {
  fetching: false,
  fetched: false,
  count: 0,
  error: null
};

export const countTaskTypeReducer = (state = initialcountTaskType, action) => {
  switch (action.type) {
    case "FETCH_NON_CATEGORIZED_TASK_TYPES_COUNT_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_NON_CATEGORIZED_TASK_TYPES_COUNT_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        count: action.payload.data.nbResult
      };
    }
    case "FETCH_NON_CATEGORIZED_TASK_TYPES_COUNT_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        fetching: false,
        count: 0,
        error
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/task-type.js